export default __webpack_public_path__ + "static/media/workshop6.21515cda.jpg";